module.exports = __webpack_public_path__ + "0a07c961dd21b1ad9aa170d13fd44ad2.png";